import { switchOptions } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import {
  getConfiguration,
  getConfigurator,
} from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Selectors';

export const actions = {
  SET_CUSTOM_DATA: 'SET_CUSTOM_DATA',
  SET_CUSTOM_COLOR: 'SET_CUSTOM_COLOR',
  TOOGLE_SHOW_CONFLICTS_ALERT: 'TOOGLE_SHOW_CONFLICTS_ALERT',
};

export const setCustomData = (data) => ({
  type: actions.SET_CUSTOM_DATA,
  data,
});

export const setCustomColor = (data) => ({
  type: actions.SET_CUSTOM_COLOR,
  data,
});

export const toggleShowConflictsAlert = (flag) => ({
  type: actions.TOOGLE_SHOW_CONFLICTS_ALERT,
  flag,
});

export const deselectMultipleOptions = (optionsList) => (dispatch, getState) => {
  const configuration = getConfiguration(getConfigurator(getState()));
  const switchOptionData = {};
  for (const component of optionsList) {
    switchOptionData[component.identifier] = component.selectedoptions.map(({ identifier }) => ({
      identifier,
      amount: 0,
      check_results: null,
    }));
  }
  return dispatch(switchOptions(configuration, switchOptionData, false, false, true));
};
